export default __webpack_public_path__ + "static/media/trading_strategies.ea492f77.png";